module.exports = __webpack_public_path__ + "images/users/opt_in_modal/main_b8d04376c276982b545b7023c65bfade.png";